import SuperFetch from "../utils/superFetch"

export const getDocumentListForMember = async (profileId) => {
    let response = await SuperFetch("/api/onboarding/driverVerificationDetails?profileType="+profileId, "GET")
    return response
}

export const updateDocument = async () => {
    let response = await SuperFetch("/api/onboarding/updateConfiguration","POST")
    return response
}

export const getVehicleMakes = async () => {
    let response = await SuperFetch("/api/onboarding/vehicleMake","GET")
    return response
}

export const getVehicleModels = async (vehicleMake) => {
    let response = await SuperFetch(`/api/onboarding/vehicleModels?vehicleMake=${vehicleMake}`,"GET")
    return response
}

export const getProfiles = async (changeProfile, profileType, serviceIdentifier) => {
    // &profileType=${profileType}&serviceIdentifier=${serviceIdentifier}

    let url = `/api/onboarding/getProfileTypes?changeProfile=${changeProfile}`
    if (profileType && profileType != null && profileType != undefined && profileType != "") {
        url += `&profileType=${profileType}`
    }
    if (serviceIdentifier && serviceIdentifier != null && serviceIdentifier != undefined && serviceIdentifier != "") {
        url += `&serviceIdentifier=${serviceIdentifier}`
    }
    let response = await SuperFetch(url,"GET")
    return response
}

export const getTaxiCompanies = async () => {
    let response = await SuperFetch("/api/onboarding/getTaxiCompanies","GET")
    return response
}